import AnimationProgress from './AnimationProgress';

import { SPRITE_WIDTH, ROTATION_RATE, SPRITE_HEIGHT } from './constants';
import type { IndividualConfetti } from './buildSprites';

type DrawFallingConfettiParams = {
  ctx: CanvasRenderingContext2D | null;
  width: number;
  height: number;
  confettiAmount: number;
  confetti: IndividualConfetti[];
  yRange: number;
  progress: AnimationProgress;
};

const drawFallingConfetti = ({
  ctx,
  width,
  height,
  confettiAmount,
  confetti,
  yRange,
  progress,
}: DrawFallingConfettiParams): void => {
  if (ctx) {
    ctx.clearRect(0, 0, width, height);
    for (let i = 0; i < confettiAmount; ++i) {
      const progressTickNow = progress.tick(performance.now());
      const sprite = confetti[i];
      ctx.save();
      ctx.translate(
        sprite.initX + sprite.rotation * ROTATION_RATE * progressTickNow,
        sprite.initY + progressTickNow * (height + yRange)
      );
      ctx.rotate(sprite.rotation);
      ctx.drawImage(
        sprite.canvas,
        (-SPRITE_WIDTH * Math.abs(Math.sin(progressTickNow * Math.PI * 2 * sprite.speed))) / 2,
        -SPRITE_HEIGHT / 2,
        SPRITE_WIDTH * Math.abs(Math.sin(progressTickNow * Math.PI * 2 * sprite.speed)),
        SPRITE_HEIGHT
      );
      ctx.restore();
    }
  }
};

export default drawFallingConfetti;
